import { Reveal } from "./Reveal";
import { REQUIREMENTS } from "@/data/content";

export const Requirements = () => {
  return (
    <section id="voraussetzungen" data-testid="requirements" className="relative py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <div className="max-w-2xl">
          <Reveal>
            <span className="font-heading text-xs font-semibold uppercase tracking-[0.24em] text-brand-blue">
              Voraussetzungen
            </span>
          </Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-5 font-heading text-4xl font-extrabold leading-[1.05] tracking-tight sm:text-5xl">
              Was brauche ich für den <span className="text-gradient-brand">Einstieg?</span>
            </h2>
          </Reveal>
        </div>

        <div className="mt-14 grid grid-cols-1 gap-5 sm:grid-cols-2">
          {REQUIREMENTS.map((r, i) => (
            <Reveal key={r.title} delay={(i % 2) * 0.1}>
              <div className="group flex h-full items-start gap-5 rounded-2xl border border-white/10 bg-brand-surface p-7 transition-colors duration-300 hover:border-brand-blue/40 sm:p-8">
                <div className="flex h-14 w-14 shrink-0 items-center justify-center rounded-xl bg-brand-blue/10 text-brand-blue transition-transform duration-300 group-hover:scale-110">
                  <r.icon className="h-7 w-7" />
                </div>
                <div>
                  <h3 className="font-heading text-xl font-bold text-white">{r.title}</h3>
                  <p className="mt-2 font-body text-sm leading-relaxed text-white/60">{r.text}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
